import { subDays } from 'date-fns';

import { toDate } from '../date/to-date';

const HIDE_BEFORE_END_DAYS = 3;

export const isCvDisplayPeriodActive = (endDate: string): boolean => {
  const parsedEndDate = toDate(endDate);

  if (!parsedEndDate) {
    return false;
  }

  return toDate(new Date())! < subDays(parsedEndDate, HIDE_BEFORE_END_DAYS);
};
